<template>
  <div class="my-orders">
    <div class="flex border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-medium">My Orders</h2>
    </div>
    <div class="py-5 lg:flex items-center justify-end">
      <!-- <div
        class="option-box flex items-center justify-between py-2"
        @mouseenter="showOptions = true"
        @mouseleave="showOptions = false"
      >
        <span class="capitalize pl-4">{{ ordersStatus }}</span>
        <img src="@/assets/icons/chevronDown.svg" class="px-4">
        <div
          v-if="showOptions"
          class="z-20 absolute top-full pt-2 inset-x-0"
        >
          <ul class="bg-white p-2 border rounded-lg border-dark-b">
            <li
              v-for="(option, index) in ordersOptions"
              :key="`option-${index}`"
              class="py-1 px-2 cursor-pointer hover:text-green"
              @click="changeOrderStatus(option)"
            >
              <span :class="{'text-green': ordersStatus === option}">
                {{ option }}
              </span>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="md:flex"> 
        <div class="option-box">
          <DateRangePicker
            ref="picker"
            opens="center"
            :autoApply="true"
            :ranges="false"
            :locale-data="localeData"
            :appendToBody="true"
            :max-date="new Date()"
            v-model="dateRange"
            @update="searchOrders"
            class="w-full"
          >
            <div slot="input" class="flex justify-between items-center w-full">
              <input
                placeholder="Search by Date"
                readonly
                :value="formattedRange"
              >
              <i class="icon-Frame text-xl text-dark opacity-50 mr-2"/>
            </div>
          </DateRangePicker>
          <i
            v-if="dateRange.endDate"
            class="material-icons absolute top-0 right-0 mt-2 mr-10 text-dark opacity-50 cursor-pointer"
            @click="removeRange"
          >
            close
          </i>
        </div>
        <div class="option-box py-2 px-3 md:ml-5">
          <input
            class="w-full"
            placeholder="Search by Keyword"
            v-model="searchKeyword"
            @keydown.enter.prevent="searchOrders"
          >
          <i class="icon-search text-dark opacity-50 absolute right-0 mr-4 text-xl"/>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center py-48">
      Loading...
    </div>
    <OrdersList v-else :ordersStatus="ordersStatus" :orders="orders" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import store from '@/store/index'
import OrdersList from '@/shared/components/profile/order/OrdersList'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'MyOrders',
  components: {
    OrdersList,
    DateRangePicker
  },
  data() {
    return {
      orders: [],
      ordersStatus: 'Pending',
      loading: false,
      searchKeyword: '',
      showOptions: false,
      dateRange: {
        startDate: null,
        endDate: null
      },
      ordersOptions: [ 'Pending', 'Accepted', 'Ready to be shipped', 'Shipped', 'Delivered', 'Canceled', 'Returned' ],
    }
  },
  watch: {
    ordersStatus() {
      this.searchOrders()
    }
  },
  async created() {
    if (!store.getters.isUserLoggedIn) { 
      localStorage.setItem('previousUrl',window.location)
      this.$router.push({name: 'LoginSelection'})
    } else {
      this.loading = true
      await this.searchOrders()
    }
  },
  computed: {
    filters() {
      let filters = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      }
      if (this.searchKeyword) filters.search = this.searchKeyword
      // if (this.ordersStatus) filters.status = this.ordersStatus 
      return filters
    },
    localeData() {
      return {
        format: "mm/dd/yyyy"
      }
    },
    formattedRange() {
      if (!this.dateRange.startDate) return ''

      const sd = this.dateRange.startDate
      const ed = this.dateRange.endDate
      return `${sd.getDate()}/${sd.getMonth() + 1}/${sd.getFullYear()} - ${ed.getDate()}/${ed.getMonth() + 1}/${ed.getFullYear()}`
    }
  },
  methods: {
    ...mapActions ([
      'fetchBuyerOrders'
    ]),
    async searchOrders() {
      const filters = this.filters
      this.orders = await this.fetchBuyerOrders(filters)
      this.loading = false
    },
    removeRange() {
      this.dateRange = { startDate: null, endDate: null }
      this.searchOrders()
    },
    changeOrderStatus(status) {
      this.ordersStatus = status
      this.showOptions = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .my-orders {
    .option-box {
      @apply relative border border-dark-b rounded-full bg-white w-full mb-2;
      @screen lg { @apply w-60 mb-0 }
      @screen xl { @apply w-64 }
    }
    /deep/.reportrange-text {
      @apply h-10 pt-2 w-full bg-transparent border-none;
      span {
        white-space: nowrap;
      }
    }
  }
</style>
